<template>
  <div>
    <el-form size="small">
      <el-row :gutter="15">
        <el-col :span="12">
          <DateForm
            ref="dateForm"
          />
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="Customer">
            <AccountAutoComplete
              ref="accountAutoComplete"
              v-model="account"
              @loadCarrier="loadCarrier"
            />
            <el-checkbox
              v-model="form.showChildrenAccts"
              label="Include Child Accounts"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Carrier">
            <CarrierAutoComplete
              ref="carrierList"
              v-model="carrier"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="8">
          <el-form-item>
            <el-checkbox
              v-model="form.internalConsOnly"
              label="Exclude Third Party & Ignored"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col>
        <el-button
          type="primary"
          size="small"
          class="float-right"
          @click.native="downloadCSV()"
        >
          Generate Report
        </el-button>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Uninvoiced Freight"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
    />
  </div>
</template>

<script>
import DateForm from '@/components/Application/Reports/DateForm'
import CarrierAutoComplete from '@/components/Application/Reports/CarrierAutoComplete'
import AccountAutoComplete from '@/components/Application/Reports/AccountAutoComplete'
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    DateForm,
    AccountAutoComplete,
    CarrierAutoComplete,
    Preview
  },
  data () {
    return {
      pageTitle: 'Uninvoiced Freight',
      breadcrumb: {
        name: 'Uninvoiced Freight',
        route: { name: 'reports-uninvoice-freight' }
      },
      account: [],
      carrierSettings: [],
      carrier: {},
      form: {
        dateFrom: null,
        dateTo: null,
        accountId: null,
        carrierId: {},
        internalConsOnly: true,
        uninvoicedOnly: true
      },
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    setDate (date) {
      this.form.dateFrom = this.$moment(date[0]).format('YYYY-MM-DD HH:mm:ss')
      this.form.dateTo = this.$moment(date[1]).format('YYYY-MM-DD HH:mm:ss')
    },
    loadCarrier () {
      this.form.accountId = this.$refs.accountAutoComplete.getAccountIds()
      this.carrierSettings = this.$refs.accountAutoComplete.getCarriers()
    },
    downloadCSV () {
      this.$refs.dateForm.$refs.form.validate(async valid => {
        if (valid) {
          this.setDate(this.$refs.dateForm.form.value)
          this.form.carrierId = this.$refs.carrierList.getCarrierId()

          this.configuration = {
            report: 'UninvoiceFreight',
            params: this.form
          }
          this.isShowPreview = true
        }
      })
    }
  }
}
</script>
